import React from 'react'

import { routes } from '@sketch/modules-common'

import { useGetRandomPublicationsQuery } from '@sketch/gql-types'

import {
  Title,
  Container,
  StyledSkeleton,
  GridPublicationItemContainer,
  Wrapper,
} from './MoreFromThisCreator.styles'
import { GridPublicationItem } from '../GridPublicationItem'

interface MoreFromThisCreatorProps {
  workspaceIdentifier: string
  exclude: string
  creatorName: string
}

const MoreFromThisCreator: React.FCC<MoreFromThisCreatorProps> = ({
  workspaceIdentifier,
  exclude,
  creatorName,
}) => {
  const { data, loading, error } = useGetRandomPublicationsQuery({
    variables: {
      workspaceIdentifier,
      exclude: [exclude],
      limit: 3,
    },
    // We want to always have new random publications when the component renders
    fetchPolicy: 'network-only',
  })

  const profile = data?.workspaceProfile

  if (loading) {
    return (
      <Wrapper>
        <Title>More from {creatorName}</Title>
        <Container>
          <StyledSkeleton />
          <StyledSkeleton />
          <StyledSkeleton />
        </Container>
      </Wrapper>
    )
  }

  if (error || !profile) {
    return null
  }

  const shortUrlName = profile.shortUrlName
  const publications = profile.publications.entries ?? []

  if (!publications.length) {
    return null
  }

  return (
    <Wrapper>
      <Title>More from {creatorName}</Title>
      <Container>
        {publications.map(publication => {
          const { identifier } = publication

          const url = routes.WORKSPACE_PROFILE_DOCUMENT.create({
            shortUrlName: shortUrlName,
            publicationId: identifier,
          })

          return (
            <GridPublicationItemContainer key={identifier}>
              <GridPublicationItem publication={publication} url={url} />
            </GridPublicationItemContainer>
          )
        })}
      </Container>
    </Wrapper>
  )
}

export default MoreFromThisCreator
